function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M-0.000976562 29.9104C-0.000976562 19.9701 -0.000976562 10.0299 -0.000976562 0C6.89455 0 13.7005 0 20.6856 0C20.6856 0.537313 20.6856 1.07463 20.6856 1.61194C20.6856 2.50746 20.6856 3.49254 20.6856 4.38806C20.6856 6.98507 20.6856 6.98507 18.4468 8.77612C18.4468 6.62687 18.4468 4.47761 18.4468 2.32836C12.9841 2.32836 7.70052 2.32836 2.23783 2.32836C2.23783 10.7463 2.23783 19.1642 2.23783 27.6716C7.61096 27.6716 12.8945 27.6716 18.3572 27.6716C18.3572 25.5224 18.3572 23.3731 18.3572 21.0448C19.1632 21.8507 19.7901 22.5672 20.4169 23.194C20.5065 23.2836 20.596 23.4627 20.596 23.6418C20.596 25.7015 20.596 27.8507 20.596 30C13.7901 29.9104 6.89455 29.9104 -0.000976562 29.9104Z",
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M26.3271 14.9555C24.6256 16.6569 22.8345 18.448 21.133 20.1495C20.5957 19.7017 20.148 19.1644 19.4315 18.5375C20.3271 17.7316 21.2226 16.9256 22.1181 16.2092C22.1181 16.1196 22.0285 16.0301 22.0285 16.0301C17.4614 16.0301 12.8047 16.0301 8.14795 16.0301C8.14795 15.2241 8.14795 14.5972 8.14795 13.7913C12.8047 13.7913 17.3718 13.7913 22.2077 13.7913C21.2226 12.8958 20.3271 12.0898 19.4315 11.1943C20.148 10.5674 20.6853 10.1196 21.2226 9.67188C22.8345 11.4629 24.6256 13.254 26.3271 14.9555Z",
  fill: "white"
});

function SvgLogout(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 30,
    viewBox: "0 0 27 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.9a741e72.svg";
export { ForwardRef as ReactComponent };